// extracted by mini-css-extract-plugin
export default {"pageWrapper":"Offline_pageWrapper__VjXXl","imgWrapper":"Offline_imgWrapper__05Ntk","title":"Offline_title__T8O7A","subtitle":"Offline_subtitle__89h45"};